interface ChevronIconProps {
    rotateUp?: boolean;
}

const ChevronIcon = ({ rotateUp = false }: ChevronIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="6"
            viewBox="0 0 9 6"
            fill="none"
            style={{ transform: rotateUp ? 'rotate(180deg)' : 'none' }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.146447 0.203637C0.341709 0.00837483 0.658292 0.00837479 0.853554 0.203637L4.5 3.85008L8.14645 0.203636C8.34171 0.00837388 8.65829 0.00837384 8.85355 0.203636C9.04882 0.398898 9.04882 0.715481 8.85355 0.910743L4.5 5.2643L0.146447 0.910744C-0.0488149 0.715482 -0.048815 0.398899 0.146447 0.203637Z"
                fill="#147BC2"
            />
        </svg>
    );
}

export default ChevronIcon;